import { Component, OnInit } from '@angular/core';
import { PropertyService } from '../../services/property.service';
import { BillingService } from '../../services/billing.service';
import { MessageService } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { ButtonDirective } from 'primeng/button';
import { DatePipe, NgIf } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { DropdownModule } from 'primeng/dropdown';
import { NewSignup } from '../../domain/new-signup';

@Component({
   selector: 'app-new-signups-management',
   templateUrl: './new-signups-management.component.html',
   styleUrls: ['./new-signups-management.component.scss'],
   standalone: true,
   providers: [MessageService],
   imports: [
      TableModule,
      ButtonDirective,
      NgIf,
      ProgressSpinnerModule,
      DatePipe,
      ToastModule,
      DropdownModule
   ]
})
export class NewSignupsManagementComponent implements OnInit {
   signups: NewSignup[] = [];
   loading = false;

   paymentCycleOptions = [
      { label: 'Monthly', value: '1' },
      { label: 'Annually', value: '12' }
   ];

   constructor(
      private billingService: BillingService,
      private propertyService: PropertyService,
      private messageService: MessageService
   ) {}

   ngOnInit(): void {
      this.fetchNewSignups();
   }

   fetchNewSignups(): void {
      this.loading = true;
      this.propertyService.getNewSignups().subscribe({
         next: (data: NewSignup[]) => {
            this.signups = data;
            this.loading = false;
         },
         error: (err) => {
            console.error(err);
            this.loading = false;
         }
      });
   }

   getPaymentCycleLabel(value: string | null): string {
      const option = this.paymentCycleOptions.find((opt) => opt.value === value);
      return option?.label || '-';
   }

   disableAccount(propertyId: number): void {
      this.propertyService.setActiveStatus(propertyId, false).subscribe({
         next: () => {
            this.messageService.add({
               severity: 'success',
               summary: 'Account Disabled',
               detail: `Property ${propertyId} has been disabled.`
            });
            this.fetchNewSignups();
         },
         error: () => {
            this.messageService.add({
               severity: 'error',
               summary: 'Error',
               detail: `Failed to disable property ${propertyId}.`
            });
         }
      });
   }

   createRepeatingInvoice(propertyId: number): void {
      this.loading = true;

      this.billingService.createRepeatingInvoice(propertyId).subscribe({
         next: (response) => {
            this.loading = false;
            this.messageService.add({
               severity: 'success',
               summary: 'Success',
               detail:
                  response.message || `Invoice created for property ${propertyId}`
            });
            this.fetchNewSignups();
         },
         error: (err) => {
            this.loading = false;
            this.messageService.add({
               severity: 'error',
               summary: 'Error',
               detail: err?.error || 'Failed to create invoice'
            });
         }
      });
   }
}
